// extracted by mini-css-extract-plugin
module.exports = {"Title":"User_Title__3BBP2"};